// 引入Vue
import Vue from 'vue'

// 引入App组件
import App from './App'

// 引入elementUI组件 2.10.1
import ElementUI from 'element-ui';

// 引入elementUI样式 2.10.1
import 'element-ui/lib/theme-chalk/index.css';

// 引入路由
import router from './router/index'

// 引入Vuex store
import store from './store'

// 引入axios
import '@/utils/axios.js';

// 引入lodash
import '@/utils/lodash.js';

// 引入localStorage
import '@/utils/localStorage.js';

// 引入moment
import '@/utils/moment.js';

// 引入临时调试变量
import '@/utils/debugger.js';

// 引入babel-polyfill
import 'babel-polyfill'

// 引入linq-js
import Enumerable from 'linq-js'

// 引入请求封装
import '@/utils/http.js'

// 引入下载插件
import '@/utils/download.js'

// 配置linq-js
Enumerable.config.as = 'em';
// Array扩展
// Enumerable.config.extends.array = true;

// 引入filter
import filter from '@/utils/filter.js'

Object.keys(filter).forEach(k => Vue.filter(k, filter[k]))
// 图片预览
import Viewer from 'v-viewer'
//引入点击放大图片插件
import 'viewerjs/dist/viewer.css'

import Print from '@/utils/print.js'
// import Print from "vue-print-nb"
Vue.use(Print) // 注册
// 通过中间件使用elementUI 使用size设置全局组件尺寸
Vue.use(ElementUI, {
    size: 'medium'
});

// 通过中间件使用路由
Vue.use(router);
// 使用图片放大
Vue.use(Viewer)
Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    }
})
// 阻止启动生产消息
Vue.config.productionTip = false

new Vue({
    el: '#app',
    // 初始化vue对象时，加载路由
    router,
    // 初始化vue对象时，加载Vuex store
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js